'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Play, Flame } from 'lucide-react';
import { useState } from 'react';
import { useSiteSettings } from '@/lib/hooks/useSiteSettings';
export function HeroSectionSizzleCPG() {
  const $ = _c(16);
  const [showVideo, setShowVideo] = useState(false);
  const {
    settings
  } = useSiteSettings();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 bg-gradient-to-br from-orange-50/60 via-white to-rose-50/40" />;
    t1 = <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-primary-100/30 blur-3xl" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Flame className="w-4 h-4 text-primary-500" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-center gap-2 mb-8">{t2}<p className="text-sm font-medium text-gray-600">Early Preview -{" "}<Link href="/early-preview" className="text-primary-600 underline hover:no-underline cursor-pointer">Learn more</Link></p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = settings.home?.hero?.title ?? `Welcome to The ${settings.sectorTerm} Growth Platform`;
  let t5;
  if ($[4] !== t4) {
    t5 = <h1 className="text-4xl sm:text-5xl lg:text-5xl font-extrabold leading-[1.3] mb-10"><span className="box-decoration-clone inline bg-gray-900 text-white px-3 py-1">{t4}</span></h1>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-xl lg:text-2xl text-gray-600 mb-10">Helping great brands and products get known, tried, purchased, and scale sales, channels, and markets.</p>;
    t7 = <p className="text-lg lg:text-xl text-gray-600">Sizzle is for:</p>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-2 mt-4">{[{
        actor: "Brands",
        value: "Boost brand and product awareness + trial"
      }, {
        actor: "Retailers",
        value: "Attract people in store and drive incremental sales"
      }, {
        actor: "Buyers",
        value: "Discover emerging brands"
      }, {
        actor: "Distributors",
        value: "Discover emerging brands"
      }, {
        actor: "Brokers",
        value: "Discover emerging brands"
      }, {
        actor: "Consultants",
        value: ""
      }, {
        actor: "Agencies",
        value: ""
      }, {
        actor: "Suppliers",
        value: ""
      }].map(_temp)}</div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t5) {
    t9 = <div>{t5}{t6}{t7}{t8}</div>;
    $[9] = t5;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== showVideo) {
    t10 = <div className="relative rounded-3xl overflow-hidden shadow-2xl ring-1 ring-black/5 bg-gray-100 aspect-[4/3] hidden lg:block">{showVideo ? <div className="absolute inset-0 flex items-center justify-center bg-black"><p className="text-white text-lg">Video player placeholder</p></div> : <><img src="https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=800&h=600&fit=crop" alt="Food and beverage products being showcased at an activation event" className="w-full h-full object-cover" onError={_temp2} /><button onClick={() => setShowVideo(true)} className="absolute inset-0 flex items-center justify-center group/play cursor-pointer" aria-label="Play video"><div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full flex items-center justify-center shadow-xl ring-4 ring-primary-100 group-hover/play:scale-110 transition-transform"><Play className="h-7 w-7 sm:h-8 sm:w-8 text-primary-600 ml-1" /></div></button></>}</div>;
    $[11] = showVideo;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <section className="relative overflow-hidden bg-white pb-16">{t0}{t1}<div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-4  lg:py-4">{t3}<div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-12 lg:gap-16 items-center">{t9}{t10}</div></div></section>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
}
function _temp2(e) {
  (e.target as HTMLImageElement).style.display = "none";
  (e.target as HTMLImageElement).parentElement.classList.add("bg-gradient-to-br", "from-orange-200", "via-primary-100", "to-amber-100");
}
function _temp(t0) {
  const {
    actor
  } = t0;
  return <div key={actor} className="flex items-start gap-2 text-base text-gray-600"><span className="text-primary-500 mt-0.5">★</span><span><span className="font-semibold text-gray-800">{actor}</span></span></div>;
}